import { Component, OnInit, ElementRef, ViewChild, ComponentFactoryResolver, SimpleChanges } from '@angular/core';
import {Consultant} from '../../../models/Consultant.model';
import {ConsultantService} from '../../../services/consultant.service';
import {CnaeService} from '../../../services/cnae.service';
import {CommonHelper} from '../../../shared/helpers/CommonHelper';
import {Router, ActivatedRoute} from '@angular/router';
import {Responsible} from '../../../models/Responsible.model';
import {UserService} from '../../../services/user.service';
import {ContractType} from '../../../shared/enums/ContractType';
import {FormGroup, FormBuilder, Validators, AbstractControl} from '@angular/forms';
import { AwsService } from '../../../services/aws.service';
import {HonorariumType} from '../../../shared/enums/HonorariumType';
import {Toast, ToastsManager} from 'ng2-toastr';
import {ConsultantSearch} from "../../../models/ConsultantSearch.model";
import { PixKeyType } from '../../../shared/enums/PixKeyType';
import * as moment from 'moment';
import * as _ from 'lodash';
import { CompaniesService } from '../../../services/companies.service';
import { ValidationErrors } from 'aws-sdk/clients/iot';
import { ArchiveService } from '../../../services/archive/archive.service';
import { CompanyService } from '../../../services/billing-letter/company.service';
import { DropdownItemFactory } from '../../../shared/factories/dropdown/dropdown-item.factory';
import { DropdownSettingsFactory } from '../../../shared/factories/dropdown/dropdown-settings.factory';
import { Contract } from '../../../models/Contract.model';
import { Additive } from '../../../models/Additive.model';
import { TerminationContract } from '../../../models/TerminationContract.model';
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
import { GUARDS } from '../../../shared/auth/Roles';
import { SapItemType } from '../../../shared/enums/SapItemType';
import { BankService } from '../../../services/bank.service';
import { ClickSignSigner } from '../../../models/ClickSignSigner.model';
import { PixValidation } from '../../../shared/helpers/PixValidation';
import { GroupDivision } from '../../../shared/enums/GroupDivision';
import { PublicConsultantService } from "../../../services/public-consultant.service";
import { ExcellenceCenter } from '../../../models/ExcellenceCenter.model';
import { ExcellenceCentersService } from '../../../services/excellenceCenters.service';
import { FreshServiceOffboardingForm } from "../../../models/FreshServiceOffboardingForm.model";
import { LeaveTypesOptions, LeaveTypesSubGroup } from "../../../shared/enums/LeaveTypes.enum";
import { LeaveType } from "../../../shared/enums/LeaveType";
import { BehaviorSubject } from "rxjs";
import { ErrorHandlerProvider } from '../../../shared/providers/errorHandler.provider';

@Component({
    selector: 'app-consultant-edit',
    templateUrl: './consultant-edit.component.html',
    styleUrls: ['./consultant-edit.component.scss']
})
export class ConsultantEditComponent implements OnInit {
    @ViewChild("contractend") contractend: ElementRef;
    @ViewChild("contracthonorarium") contracthonorarium: ElementRef;
    @ViewChild("openModalInfra") openModalInfra: ElementRef;
    @ViewChild("closeModalAdditive") closeModalAdditive: ElementRef;
    @ViewChild("buttonOpenModalContract") buttonOpenModalContract: ElementRef;
    @ViewChild("buttonOpenInputValueModal") buttonOpenInputValueModal: ElementRef;
    consultant: Consultant = new Consultant();
    responsibles: Responsible[] = new Array<Responsible>();
    bps: Responsible[] = new Array<Responsible>();
    options: any;
    emailPattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    emailPatternFC = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
    cpfPattern = /^([0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2})$/i;
    accountMask = [/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,] ;
    agencyMask = [/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/] ;
    digitMask = [/[A-Za-z0-9]/];
    bankCodeMask = [/[0-9]/,/[0-9]/,/[0-9]/];
    consultantForm: FormGroup;
    honorarium: Boolean;
    showSoldHoursValue: Boolean;
    contractGenerated: Boolean;
    distractGenerated: Boolean = false;
    showOperationContract: Boolean;
    consultantSearch = new ConsultantSearch();
    mask = [/[0-3]/,/[0-9]/,'/',/[0-3]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/];
    phoneMask = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] ;
    errors = [];
    user;
    redirect: Boolean = true;
    sendEmailInfra = false;
    sendEmailDepartments = false;
    bondConsultantPJ = false;
    bondConsultantCLT = false;
    blockAdditive = false;
    optionLaptop = 1;
    optionEmail = 1;
    laptopValid = false;
    laptopReturnedChecked = false;
    laptopAccordChecked = false;
    indexModalInfra: Number = 997;
    indexDateContrat: Number = 998;
    indexContractAdditive: Number = 999;
    additiveHistory: Additive = new Additive();
    withoutCompany: Boolean = false;

    selectedDocument: any;
    documentSigners: ClickSignSigner[] = new Array<ClickSignSigner>();
    dropdownSigners: any;
    selectedUserWithKey: any;
    isUserInList = false;
    isNewSignerFormOpen = false;
    newSignerForm: FormGroup;
    isCpfValid = false;
    signerListLength = new Array();
    hasRepeatedGroups = false;
    generateDocumentType = 0;
    selectedAdditiveToAprove: any;

    fileList;
    fileListTerminationForm;
    selectedFiles:FileList;
    downloadUrl:string = '';
    downloadUrlTerminationConsultant:string = '';
    currentStep = 'contracts';
    optionDistract = 2;
    additiveOption: Number = 0;

    customers: any = [];
    skills: any = [];
    customersDropdown = { list: [], options: null, selected: [] };
    skillsDropdown = { list: [], options: null, selected: [] };

    loading;
    cnaes = [];
    occupations = [];
    documentsClickSign = [];
    blockLoggedUser: Boolean = false;
    pixKeyVerifyMethod : any;
    pixCpfValid : Boolean;
    pixCnpjValid : Boolean;
    textMask;

    banks : any = [];
    bankForEdit: any = [];
    bankCode: Number;
    bankName: string;
    bankCountry: string;

    showHourValueBenefits: boolean = false;

    typeAdtiveModal: any;
    typeContractModal: string;
    funcContractModal: Function;
    typeFunctionModal: number;
    reloadDocModal: boolean = false;
    contractDataInvalid: boolean = false;
    personalDataInvalid: boolean = false;

    distractInProgress: boolean = false;
    dischargeInProgress: boolean = false;
    hidePrivateData: Boolean = false;
    isUserFinances: Boolean = false;
    isUserBp: Boolean = false;
    isUserAccounting: Boolean = false;
    isUserPeople = false;
    LeaveTypes = LeaveType;

    GUARDS = GUARDS;
    canSave: Boolean = true;
    allowedRoles = [GUARDS.MANAGER, GUARDS.GOVERNANCE, GUARDS.FINANCES, GUARDS.JUDICIARY, GUARDS.DP, GUARDS.BUSINESSPARTNER, GUARDS.ACCOUNTING, GUARDS.PEOPLE];
    allowedToChangeBond = [GUARDS.GOVERNANCE, GUARDS.BUSINESSPARTNER, GUARDS.DP, GUARDS.PEOPLE];
    canChangeConsultantBond = true;
    isBlockedByDivision: boolean = false;
    consultantId: string;

    showHourValue: boolean = false;
    showTotalValue: boolean = false;
    showMensalHours: boolean = false;
    disableHourValue: boolean = false;

    showBtnNewAdditiveReadjustment: boolean = true;
    showBtnNewAdditiveRenew: boolean = true;
    showBtnNewAdditiveChangeCompany: boolean = true;

    disableContractFields: Boolean = false;
    validDateAdditive: Boolean = false;
    excellenceCenters: Array<ExcellenceCenter> = [];
    supportCenters: Array<ExcellenceCenter> = [];
    auxSupportCenter;

    blockDpToAccessConsultantPJ: boolean = false;
    leaveTypesSubGroups = [];
    pendingGovOrDpApproval = false;
    ContractTypes = ContractType;
    completedOffboardingForm: boolean = false;

    newAdditiveIncluded: boolean = false;
    selectedAdditiveByGovApproval = new Additive();
    additiveIndex = -1;
    allowedToFillFinishBondForms = false;
    constructor(private router: Router,
                private route: ActivatedRoute,
                private userService: UserService,
                private formBuilder: FormBuilder,
                private toastr: ToastsManager,
                public consultantService: ConsultantService,
                public commonHelper: CommonHelper,
                private archiveService:ArchiveService,
                private awsService:AwsService,
                private companyService: CompanyService,
                private companiesService: CompaniesService,
                private dropDownItemFactory: DropdownItemFactory,
                private dropDownSettingFactory: DropdownSettingsFactory,
                private localStorage: LocalStorage,
                private cnaeService:CnaeService,
                private bankService: BankService,
                public pixValidation: PixValidation,
                private publicConsultantService: PublicConsultantService,
                private excellenceCentersService: ExcellenceCentersService,
                private LeaveTypesGroups: LeaveTypesSubGroup,
                private errorHandler: ErrorHandlerProvider,
            ) { }

    async ngOnInit() {
        this.loading = true;

        this.checkPermissions();

        this.user = this.localStorage.retrieve('user');
        this.consultantForm = this.formBuilder.group({
            name: [null, Validators.required],
            begin:[null, Validators.required],
            email: [null, [Validators.email]],
            fcEmail: [null, [Validators.required, Validators.email]],
            contractKind: [null, [this.validateSelectOption]],
            rg: [null, [Validators.required]],
            cpf: [null, [Validators.required, Validators.pattern(this.cpfPattern)]],
            sex: [null, [this.validateSelectOption]],
            civilStatus: [null, [this.validateSelectOption]],
            cep: [null, null],
            address: [null, null],
            number: [null, null],
            district: [null, null],
            city: [null, null],
            state: [null, null],
            responsible: [null, [this.validateSelectOptionResponsible]],
            bp: [null, [this.validateSelectOptionBP]],
            keyPix:[null, [this.validateKeyPix]],
            bank: [null, Validators.required],
            agency: [null, Validators.required],
            account: [null, Validators.required],
            digit: [null, Validators.required],
            born: [null, Validators.required],
            consultantStart: [null, Validators.required],
            cellPhone: [null, Validators.maxLength(20)],
            position: [null, null],
            excellenceCenter: [null, [this.validateSelectOptionExcellenceCenter]],
            supportCenter: [null, null]
        });

        var idConsultant = this.route.snapshot.params['id'];
        this.consultant = await this.consultantService.getById(idConsultant);
        this.consultant.personal.born = moment(this.consultant.personal.born).format("DDMMYYYY");
        this.consultant.contract.begin = moment(this.consultant.contract.begin).format("DDMMYYYY");
        this.consultant.consultantStart = moment(this.consultant.consultantStart).format("DDMMYYYY");
        if(this.consultant.contract.end)
            this.consultant.contract.end = moment(this.consultant.contract.end).format("DDMMYYYY");
        if(this.consultant.contract.regularizationDate)
            this.consultant.contract.regularizationDate = moment(this.consultant.contract.regularizationDate).format("DDMMYYYY");
        if(this.consultant.consultantEnd)
            this.consultant.consultantEnd = moment(this.consultant.consultantEnd).format("DDMMYYYY");
        if(this.consultant.contract.termination.start)
            this.consultant.contract.termination.start = moment(this.consultant.contract.termination.start).format("DDMMYYYY");
        if(this.consultant.contract.termination.end)
            this.consultant.contract.termination.end = moment(this.consultant.contract.termination.end).format("DDMMYYYY");

        if(this.consultant.contract.additivesHistory && this.consultant.contract.additivesHistory.length > 0){
            this.consultant.contract.additivesHistory = this.consultant.contract.additivesHistory.map(additive => {
                if(additive.date) additive.date = moment(additive.date).format("DDMMYYYY");
                if(additive.createdAt) additive.createdAt = moment(additive.createdAt).format("DDMMYYYY");
                return additive;
            });
        }

        if(this.consultant.contractsHistory && this.consultant.contractsHistory.length > 0){
            this.consultant.contractsHistory = this.consultant.contractsHistory.map(contract => {
                if(contract.begin) contract.begin = moment(contract.begin).format("DDMMYYYY");
                if(contract.end) contract.end = moment(contract.end).format("DDMMYYYY");
                return contract;
            });
        }

        this.consultant.contract.additivesHistory.forEach(adt => {
            if(adt.pendingApproval || adt.pendingGovApproval)
                this.blockAdditive = true;
        });

        if(this.consultant.payment.typePix == 0) {
            this.consultantForm.get("keyPix").disable();
        }

        if(this.consultant.payment.keyPix){
            this.textMask = {mask: false}
        }

        this.laptopValid = (this.consultant.contract.termination.laptopReturned || this.consultant.contract.termination.returnAgreement) ? true : false;

        this.customers = await this.companyService.getAll();
        this.customers = _.orderBy(this.customers,[company => company.name.toUpperCase()]);
        this.customersDropdown.options = this.dropDownSettingFactory.build({text:'Clientes'});
        this.customersDropdown.list = this.dropDownItemFactory.build({source:this.customers});
        this.customersDropdown.selected = this.dropDownItemFactory.build({source:this.consultant.contract.customers});

        this.skills = await this.consultantService.getAllSkills();
        this.skillsDropdown.options = this.dropDownSettingFactory.build({text:'Skills'});
        this.skillsDropdown.list = this.dropDownItemFactory.build({source:this.skills});
        this.skillsDropdown.selected = this.dropDownItemFactory.build({source:this.consultant.skills});

        let kind = this.consultant.contract.kind;
        let honor = this.consultant.contract.honorarium;

        if (kind === ContractType.CLT) {
            this.disableHourValue = true;
            this.showHourValue = true;
            this.showTotalValue = true;
            this.showSoldHoursValue = true;
            this.showMensalHours = true;
            this.showHourValueBenefits = true;
        }
        if (kind === ContractType.PJ && honor === HonorariumType.HoraAberta) {
            this.showHourValue = true;
            this.disableHourValue = false;
            this.showMensalHours = false;
            this.showTotalValue = false;
            this.showSoldHoursValue = true;
            this.showHourValueBenefits = false;
        }

        if (kind === ContractType.PJ && honor === HonorariumType.HoraFechada) {
            this.showHourValue = true;
            this.disableHourValue = true;
            this.showMensalHours = true;
            this.showTotalValue = true;
            this.showSoldHoursValue = true;
            this.showHourValueBenefits = false;
        }

        if (kind === ContractType.Estagiario || kind === ContractType.Outros) {
            this.showHourValue = true;
            this.disableHourValue = false;
            this.showMensalHours = true;
            this.showTotalValue = true;
            this.showSoldHoursValue = true;
            this.showHourValueBenefits = false;
        }

        if(!this.laptopValid && !this.consultant.active){
            this.bondConsultantPJ = true;
        }

        this.banks = await this.bankService.getBanks();
        this.responsibles = await this.userService.getAllUsersAsResponsibles();
        this.bps = [...this.responsibles];
        this.options = this.commonHelper.getDatePickerOptions();

        //set status contract
        if(!this.consultant.contract.generated){
            if(this.consultant.contract.cnpj != '' && this.consultant.contract.companyName != '')
                this.consultant.contract.contractStatus = 1
            else
                this.consultant.contract.contractStatus = 5
        }

        await this.getS3Files();
        if(this.fileList.length > 0){
            this.download(this.fileList[0].Key);
        }

        this.occupations = await this.consultantService.getAllContractProfile();
        this.cnaes = await this.cnaeService.getAllItems([SapItemType.CnaeConsultant]);
        this.distractGenerated = this.consultant.contract.termination.documentGenerated ? true : false;

        if(this.consultant.contract.companyName == '' || this.consultant.contract.companyName == null){
            this.withoutCompany = true;
        }

        //validação de usuário logado para bloqueio de dados sensíveis
        this.loggedUserValidation();
        this.currentStep = 'personal';

        if(!this.consultant.payment.typePix) {
            this.consultant.payment.typePix = 0
            this.consultantForm.get("keyPix").disable();
        }

        if(this.consultant.supportCenter){
            this.auxSupportCenter = this.consultant.supportCenter._id
        }

        const allExcellenceCenters = await this.excellenceCentersService.getAll();

        this.excellenceCenters = allExcellenceCenters.filter(center => center.type == 1 );
        this.excellenceCenters = _.orderBy(this.excellenceCenters, [sup => sup.name.toUpperCase()]);

        this.supportCenters = allExcellenceCenters.filter(center => center.type == 2);
        this.supportCenters = _.orderBy(this.supportCenters, [sup => sup.name.toUpperCase()]);

        this.leaveTypesSubGroups = [...this.LeaveTypesGroups.leaveTypes] as LeaveTypesOptions[];
        if (!this.consultant.active) {
            this.pendingGovOrDpApproval = this.consultant.contract.termination.pendingDPApproval ||
                this.consultant.contract.termination.pendingGovApproval

            if (this.pendingGovOrDpApproval && this.consultant.contract.kind === ContractType.CLT) {
                await this.getS3FilesConsultantTermination(this.consultant._id);
            }
        };

        this.loading = false;
    }

    checkPermissions() {
        this.consultantId = this.route.snapshot.params['id'];
        this.user = this.localStorage.retrieve('user');
        let permission = this.user.permission;

        if(!this.allowedRoles.includes(permission)) {

            this.canSave = false;
        }

        if (!this.allowedToChangeBond.includes(permission))
            this.canChangeConsultantBond = false;

        if(permission === GUARDS.INFRA || permission === GUARDS.ADMINISTRATIVE){
            this.router.navigate(['consultants', 'public-consultant-edit', this.consultantId])
        } else if(permission == GUARDS.COMMERCIAL) {
            this.isBlockedByDivision = false;
        } else if(permission == GUARDS.FINANCES ){
            this.isUserFinances = true;
        } else if (permission  == GUARDS.RS) {
            this.hidePrivateData = true;
        }else if(permission  == GUARDS.DP) {
            this.blockDpToAccessConsultantPJ = this.consultant.contract.kind === ContractType.PJ;
        }else if(permission == GUARDS.ACCOUNTING) {
            this.currentStep = 'personal';
            this.isUserAccounting = true;
        }

        if (permission === GUARDS.BUSINESSPARTNER) {
            this.isUserBp = true;
        }

        if (permission === GUARDS.PEOPLE)
            this.isUserPeople = true;
    }

    validateSelectOptionResponsible(control: AbstractControl) {
        if (control.value === undefined || control.value == 'undefined')
            return {responsible: true};

        return null;
    }

    validateSelectOptionBP(control: AbstractControl) {
        if (control.value === undefined || control.value == 'undefined')
            return {bp: true};

        return null;
    }

    validateSelectOption(control: AbstractControl) {
        if (control.value == 0)
            return {contractKind: true};

        return null;
    }

    validateSelectOptionExcellenceCenter(control: AbstractControl) {
        if (control.value === undefined || control.value == 'undefined')
            return {excellenceCenter: true};

        return null;
    }

    validateSelectOptionSupportCenter(control: AbstractControl) {
        if (control.value === undefined || control.value == 'undefined')
            return {supportCenter: true};

        return null;
    }

    trim(name){
        if(this.consultant[name])
            this.consultant[name] = this.consultant[name].trim();
    }

    trimPixKey(){
        if(this.consultant.payment.keyPix)
            this.consultant.payment.keyPix = this.consultant.payment.keyPix.trim();
    }

    trimNewSigner(field: any) {
      if(this.newSignerForm.get(`${field}`).value) {
          const removeWhiteSpace = this.newSignerForm.get(`${field}`).value;
          this.newSignerForm.get(`${field}`).patchValue(removeWhiteSpace.trim());
      }
    }

    async edit() {
        if (this.consultantForm.valid == false) {
            let errors = [];
            Object.keys(this.consultantForm.controls).forEach(control => {
                const controlErrors = this.consultantForm.get(control).errors
                if(controlErrors != null){
                    Object.keys(controlErrors).forEach(error =>{
                        let field = this.getVerboseField(control);
                        if(error == 'email'){
                            errors.push(`${field.verbose}: Formato de e-mail inválido`)
                        }

                        if(error == 'required' || error == 'responsible' || error == 'bp' ||
                            error == 'bank' || error == 'pixType' || error == 'keyPix' ||
                            error == 'contractKind' || error == 'excellenceCenter'){
                            errors.push(`Preencha o campo ${field.verbose}`)
                        }

                        if(error == 'maxlength'){
                            errors.push(`O campo ${field.verbose} ultrapassa o limite de caracteres`)
                        }

                    });
                }
            });
            this.errors = errors;
            return;
        }

        this.consultant.responsible.name = this.responsibles.find(x => x._id === this.consultant.responsible._id).name;
        this.consultant.bp.name = this.bps.find(x => x._id === this.consultant.bp._id).name;
        this.consultant.fcEmail = this.consultant.fcEmail.toLowerCase();
        this.consultant.excellenceCenter = this.excellenceCenters.find(ec => ec._id == this.consultant.excellenceCenter._id);
        this.consultant.supportCenter = this.checkSupportCenter(this.auxSupportCenter);

        try {

            if(this.documentsInProgressIncomplete())
                return;

            if(this.consultant.active == false){
                if(this.bondConsultantCLT && this.consultant.contract.kind !== 1){//CLT
                    this.consultant.active = true;
                }
            } else {
                //encerramento de vinculo
                if(this.bondConsultantPJ || this.bondConsultantCLT){
                    if (this.consultant.contract.termination && !this.consultant.contract.termination.cancelEmail && !this.consultant.contract.termination.emailAlternativeRedirect) {
                        return this.toastr.warning("Se a opção de cancelar e-mail for 'Não', preencha qual será o e-mail alternativo de redirecionamento...", 'ATENÇÃO!');
                    }

                    const isHourUnfilled = !this.consultant.contract.termination.qtdHours;
                    //BP preenche o campo de horas pra PJ e CLT, os demais usuários apenas pra termo de quitação PJ
                    const isHoursFieldInvalid = (!this.isUserBp && this.dischargeInProgress && isHourUnfilled) || (this.isUserBp && isHourUnfilled);
                    const isLeaveTypeInvalid = !this.consultant.contract.termination.leaveType || Number(this.consultant.contract.termination.leaveType) == 0;

                    if (this.consultant.active && (isHoursFieldInvalid || isLeaveTypeInvalid)) {
                        let message = this.consultantService.isContractTypePJ(this.consultant) ? 'encerramento de vínculo' : 'inativação'
                        return this.toastr.error(`Para prosseguir com o processo de ${message} do consultor, preencha os campos obrigatórios.`, 'ATENÇÃO');
                    }

                    if(!this.completedOffboardingForm) {
                        return this.toastr.error('É obrigatório o preenchimento do formulário de Offboard do Portal Infra', 'ATENÇÃO!');
                    }

                    if(this.bondConsultantCLT && this.consultant.contract.kind !== ContractType.PJ){//CLT
                        if(!this.consultant.consultantEnd)
                            return this.toastr.error('A data fim do consultor não foi preenchida.', 'Erro ao salvar o encerramento do consultor');
                    }

                    if (this.bondConsultantPJ && this.consultant.contract.kind === ContractType.PJ) {
                        if(!this.consultant.contract.end || !this.consultant.contract.termination.end)
                            return this.toastr.error('A data fim de contrato ou data fim do encerramento não foi preenchida.', 'Erro ao salvar o encerramento do consultor');
                    }

                    this.consultant.active = false;
                    if(this.consultant.newContract) {
                        this.consultant.active = true;
                        this.consultant.contract.termination.pendingDPApproval = false;
                        this.consultant.contract.termination.pendingGovApproval = false;
                    }
                }
            }

            //Verifica se houve aditivo (reajuste, renovação, alteração cnpj)
            if(this.newAdditiveIncluded) {
                this.additiveHistory.pendingApproval = true;
                if(this.user.permission != GUARDS.GOVERNANCE) {
                    this.additiveHistory.pendingGovApproval = true;
                }
                this.consultant.contract.additivesHistory.push(this.additiveHistory);
            }

            this.loading = true;
            let result = await this.consultantService.edit(this.consultant);
            if(this.redirect){
                this.loading = false;
                if(result._id) {
                     //Notificação e abertura de chamado à Infra somente se o encerramento do consultor for salvo com sucesso.
                     if(this.sendEmailInfra){
                        await this.notifyDepartament(5);
                        await this.createServiceTicket('offboarding');
                    }

                    if(this.sendEmailDepartments) {
                        await this.notifyDepartament(1);
                    }

                    if(this.newAdditiveIncluded) {
                        this.toastr.success("O aditivo foi cadastrado e está pendente de aprovação. Uma notificação foi enviada ao setor responsável.", '', { timeOut: 9000 });
                        if(this.additiveHistory.additiveType == 1) {
                            await this.consultantService.notifyDP(this.consultant, 9, 1);
                        } else if(this.additiveHistory.additiveType == 3) {
                            await this.consultantService.notifyDP(this.consultant, 9, 3);
                        }
                    }

                    //notificação para o jurídico sobre inclusão de empresa
                    if(this.consultant.contract.kind == 1 && this.withoutCompany && this.consultant.contract.companyName != '' && this.consultant.contract.companyName != null){
                        await this.consultantService.notifyDP(this.consultant, 10, 0);
                    }

                    this.router.navigate(['/consultants']);
                    this.toastr.success('Consultor atualizado com sucesso!');

                } else {
                    this.toastr.warning(result);
                }
            } else {
                this.loading = false;
                return result;
            }
        } catch (err) {
            this.loading = false;
            console.log(err)
            this.toastr.error("Erro ao atualizar consultor!");
            if(this.redirect){
                this.router.navigate(['/consultants']);
            }
        }
    }

    async approveAdditiveByGov(i: number, additive: Additive): Promise<void>{
        try {
            let additiveAux: Additive = _.cloneDeep(additive);
            additiveAux.pendingGovApproval = false;

            this.additiveHistory = additiveAux;
            this.consultant.contract.additivesHistory.splice(i, 1);
            this.newAdditiveIncluded = true;

            await this.edit();
            this.closeModalAdditive.nativeElement.click();
        } catch(err) {
            this.toastr.error("Erro ao aprovar aditivo!");
            this.loading = false;
        }
    }

    async inputAdditiveValueModal(index: number): Promise<void> {
        const additive = this.consultant.contract.additivesHistory[index];
        if (additive.additiveType !== 1) {
            await this.approveAdditiveByGov(index, additive);
            return;
        }
        this.selectedAdditiveByGovApproval = _.cloneDeep(additive);
        this.additiveIndex = index;
        this.buttonOpenInputValueModal.nativeElement.click();
    }

    async getAdditiveSoldHourValue(additive: Additive) {
        const additiveData = _.cloneDeep(additive);
        await this.approveAdditiveByGov(this.additiveIndex, additiveData);
    }

    async approveAdditive(i){
        try {
            this.toastr.warning('Preparando aditivo...');
            let additiveAux = new Additive();
            let history = new Additive();

            additiveAux = this.consultant.contract.additivesHistory[i];

            if(additiveAux.additiveType == 1){
                if(!this.validateDocumentGeneration('additiveValueAdjustment')) return;
            } else if(additiveAux.additiveType == 3) {
                if(!this.validateDocumentGeneration('additiveChangeCompany')) return;
            }

            history.additiveType = additiveAux.additiveType;
            history.date = additiveAux.date;
            history.honorarium = this.consultant.contract.honorarium;
            history.totalValue = this.consultant.contract.totalValue;
            history.mensalHours = this.consultant.contract.mensalHours;
            history.soldHourValue = this.consultant.contract.soldHourValue;
            history.hourValue = this.consultant.contract.hourValue;
            history.oldCompanyName = this.consultant.contract.companyName;
            history.oldCnpj = this.consultant.contract.cnpj;
            history.oldCompanyAddress = this.consultant.contract.address;
            history.oldCompanyNumber = this.consultant.contract.number;
            history.oldCompanyCep = this.consultant.contract.cep;
            history.oldCompanyCity = this.consultant.contract.city;
            history.oldCompanyDistrict = this.consultant.contract.district;
            history.oldCompanyState = this.consultant.contract.state;
            history.cnae = this.consultant.contract.cnae;
            history.pendingApproval = false;

            this.consultant.contract.additivesHistory.splice(i, 1);

            if(additiveAux.additiveType == 1){
                this.consultant.contract.mensalHours = additiveAux.mensalHours;
                this.consultant.contract.soldHourValue = additiveAux.soldHourValue;
                this.consultant.contract.hourValue = additiveAux.hourValue;
                this.consultant.contract.totalValue = additiveAux.totalValue;
                this.consultant.contract.honorarium = additiveAux.honorarium;
            } else if(additiveAux.additiveType == 3){
                this.consultant.contract.companyName = additiveAux.oldCompanyName;
                this.consultant.contract.cnpj = additiveAux.oldCnpj;
                this.consultant.contract.address = additiveAux.oldCompanyAddress;
                this.consultant.contract.number = additiveAux.oldCompanyNumber;
                this.consultant.contract.cep = additiveAux.oldCompanyCep;
                this.consultant.contract.city = additiveAux.oldCompanyCity;
                this.consultant.contract.district = additiveAux.oldCompanyDistrict;
                this.consultant.contract.state = additiveAux.oldCompanyState;
                this.consultant.updateCNPJ = true;

                if(additiveAux.cnae && additiveAux.cnae != history.cnae) {
                    this.consultant.contract.cnae = additiveAux.cnae;
                    this.changeCnae();
                }
            }

            this.consultant.contract.additivesHistory.push(history);
            this.redirect = false;

            let res = await this.edit();
            if(res._id){
                if(additiveAux.additiveType == 3){
                    additiveAux.oldCompanyName = history.oldCompanyName;
                    additiveAux.oldCnpj = history.oldCnpj;
                    additiveAux.oldCompanyAddress = history.oldCompanyAddress;
                    additiveAux.oldCompanyNumber = history.oldCompanyNumber;
                    additiveAux.oldCompanyCep = history.oldCompanyCep;
                    additiveAux.oldCompanyCity = history.oldCompanyCity;
                    additiveAux.oldCompanyDistrict = history.oldCompanyDistrict;
                    additiveAux.oldCompanyState = history.oldCompanyState;
                }
                this.loading = true;
                await this.generateAdditive(additiveAux);
                this.closeModalAdditive.nativeElement.click();
            } else {
                this.toastr.error(`Erro interno no sistema`);
            }
            this.loading = false;
        } catch (error) {
            this.toastr.error(`Erro interno no sistema`);
            this.loading = false;
        }
    }

    async disapproveAdditive(i){
        this.consultant.contract.additivesHistory.splice(i, 1);
        await this.edit();
        this.closeModalAdditive.nativeElement.click();
    }

    async notifyDepartament(op){
        try {
            switch(op){
                case 1: // Departments for approval
                    await this.consultantService.notifyDP(this.consultant, op, 0);
                    this.toastr.success('Um e-mail foi enviado aos departamentos competentes para realizarem a aprovação do encerramento de vínculo');
                    break;
                case 2: // Responsavel divisão
                    if(this.optionLaptop == 2 || this.optionLaptop == 3 || this.optionLaptop == 4){
                        await this.consultantService.notifyDP(this.consultant, op, this.optionLaptop);
                        if(!this.consultant.contract.termination.returnAgreement){
                            this.toastr.success('Devolução de Laptop confirmada ou acordada');
                            this.toastr.success('Um e-mail foi enviado para o responsável pela divisão');
                        }
                    }
                    this.router.navigate(['/consultants']);
                    break;
                case 3: // Jurídico
                    await this.consultantService.notifyDP(this.consultant, op, 0);
                    this.toastr.success('Um e-mail foi enviado para o setor Jurídico');
                    break;
                case 5: // Infra
                    await this.consultantService.notifyDP(this.consultant, op, 0);
                    this.toastr.success('Um e-mail foi enviado para o setor de Infraestrutura');
                    break;
                default:
                    return false;
            }
        } catch(err) {
            this.errorHandler.interceptError(err, 'Consultor');
        }
    }

    verifyValidTouched(fieldName) {
        return !this.consultantForm.get(fieldName).valid;
    }

    applyErrorCss(fieldName) {
        return {
            'has-error': this.verifyValidTouched(fieldName)
        }
    }

    getVerboseField(name){
        return _.find(this.commonHelper.getConsultantVerboseFields(),{name:name});
    }

    changedContractType() {

        this.consultant.contract.mensalHours = 0;
        this.consultant.contract.soldHourValue = 0;
        this.consultant.contract.hourValue = 0;
        this.consultant.contract.totalValue = 0;

        this.consultant.contract.honorarium = 0;

        let kind = this.consultant.contract.kind;
        this.showSoldHoursValue = true;

        if (kind === ContractType.CLT) {
            this.consultant.contract.mensalHours = 168;
            this.consultant.contract.hourValue = this.consultantService.calculateHourValue(this.consultant);
            this.showTotalValue = true;
            this.showHourValue = true;
            this.disableHourValue = true;
            this.showMensalHours = true;
            this.showSoldHoursValue = true;
            this.showHourValueBenefits = true;
            this.consultantForm.get('position').setValidators(null);
        }

        if (kind === ContractType.Estagiario || kind === ContractType.Outros) {
            this.showTotalValue = true;
            this.showMensalHours = true;
            this.showHourValue = true;
            this.disableHourValue = false;
            this.showHourValueBenefits = false;
            this.consultantForm.get('position').setValidators(null);
        }

        if (kind === ContractType.PJ) {
            this.showTotalValue = false;
            this.showHourValue = false;
            this.showMensalHours = false;
            this.disableHourValue = false;
            this.showHourValueBenefits = false;
            this.consultantForm.get('position').setValidators([this.validateSelectOption]);
        }

        this.consultantForm.get('position').updateValueAndValidity({onlySelf: false, emitEvent: false});
    }

    checkSupportCenter(supportId){
        if(supportId !== undefined && supportId !== null) {
            return this.supportCenters.find(cs => cs._id == supportId);
        }
        return null
    }

    addContract(){
        let contractHistory = Object.assign({}, this.consultant.contract);
        this.consultant.contractsHistory.push(contractHistory)

        this.consultant.contract = new Contract();
        this.additiveHistory = new Additive();
        if(!this.consultant.active){
            this.consultant.active = true;
        }

        this.consultant.newContract = true;

    }

    restoreContract(c){
        let newContract = new Contract();
        newContract = Object.assign(newContract, c);
        this.consultant.contract = newContract;
        this.consultant.contract.begin = '';//moment(this.consultant.contract.begin).format("DDMMYYYY");
        this.consultant.contract.end = '';//moment(this.consultant.contract.end).format("DDMMYYYY");
        this.consultant.contract.additivesHistory = [];
        this.consultant.contract.generated = false;
        this.consultant.contract.active = true;
        this.consultant.contract.termination = new TerminationContract();
        this.additiveHistory = new Additive();
        this.consultant.active = true;
        this.toastr.warning("Restaurando contrato...");
    }

    setAdditiveOption(op){
        this.validDateAdditive = false;
        this.additiveOption = op;
        if(!this.newAdditiveIncluded)
            this.additiveHistory.date = "";
    }

    changedHonorarium() {
        let honor = this.consultant.contract.honorarium;
        this.showSoldHoursValue = true;

        if (honor === HonorariumType.HoraAberta) {
            this.showTotalValue = false;
            this.showHourValue = true;
            this.showMensalHours = false;
            this.disableHourValue = false;
            this.showHourValueBenefits = false;
        }

        if (honor === HonorariumType.HoraFechada) {
            this.consultant.contract.mensalHours = 168;
            this.consultant.contract.hourValue = this.consultantService.calculateHourValue(this.consultant);
            this.showTotalValue = true;
            this.showHourValue = true;
            this.disableHourValue = true;
            this.showMensalHours = true;
            this.showHourValueBenefits = false;
        }
    }

    changeBond(){
        if(!this.bondConsultantPJ || (this.consultant.active && this.bondConsultantCLT)){
            this.openModalInfra.nativeElement.click();
        }
    }

    closeModalBond(){
        this.consultant.active = true;
        this.bondConsultantPJ = false;
        this.bondConsultantCLT = false;
        this.sendEmailInfra = false;
        this.sendEmailDepartments = false;
        this.consultant.contract.termination.pendingGovApproval = false;
        this.consultant.contract.termination.pendingDPApproval = false;
    }

    notifyInfra() {
        this.sendEmailInfra = true;
    }

    notifyDepartmentsForApproval() {
        this.sendEmailDepartments = true;
    }

    startFillingConsultantTermination(){
        this.setApprovalFlag(this.user.permission);
        this.finishBondFormAllowedPermission();
        const now = new Date();
        let generated = this.consultant.contract.generated;
        if(generated){
            this.consultant.contract.termination.start = this.consultant.contract.begin;
            this.consultant.contract.termination.end = this.consultant.contract.end ? this.consultant.contract.end : moment(now).format("DDMMYYYY");
            if(!this.consultant.contract.end){
                this.consultant.contract.end = this.consultant.contract.termination.end
            }
            if(!this.consultant.consultantEnd){
                this.consultant.consultantEnd = this.consultant.contract.termination.end
            }
            if(this.consultant.contract.kind === ContractType.PJ) this.distractInProgress = true;
        } else{
            this.consultant.contract.termination.start = this.consultant.consultantStart;
            this.consultant.contract.termination.end = moment(now).format("DDMMYYYY");
            if(!this.consultant.consultantEnd){
                this.consultant.consultantEnd = this.consultant.contract.termination.end
            }
            if(!this.consultant.contract.end){
                this.consultant.contract.end = this.consultant.contract.termination.end
            }
            if(this.consultant.contract.kind === ContractType.PJ) this.dischargeInProgress = true;
        }
    }

    async generateContract(){
        try{
            if(!this.validateDocumentGeneration('contract'))
                return;

            if(this.consultant.contract.generated == false){
                this.consultant.active = true;
                this.consultant.contract.contractStatus = 4;

                this.redirect = false;
                let res = await this.edit();
                if(res._id) {
                    this.toastr.warning("Gerando contrato...");
                    this.loading = true;
                    const response = await this.consultantService.generateContract(this.consultant);
                    if(response.success){
                        this.consultant.contract.generated = true;
                        this.toastr.success('Contrato gerado com sucesso!');
                        this.toastr.success('Consultor atualizado!');
                    } else {
                        this.toastr.error('Falha ao gerar contrato', 'Módulo Consultor');
                    }
                } else {
                    this.toastr.error('Erro interno no servidor', 'Módulo Consultor');
                }
                this.loading = false;
            }
        } catch (error) {
            this.toastr.error('Erro interno no servidor', 'Módulo Consultor');
            this.loading = false;
        }
    }

    async generateAdditive(additive){
        try{
            if(additive.additiveType == 1)
                this.toastr.warning("Gerando termo aditivo...");
            else if(additive.additiveType == 2)
                this.toastr.warning("Gerando renovação de contrato...");
            else if(additive.additiveType == 3)
                this.toastr.warning("Gerando alteração de dados...");

            this.loading = true;
            let responseAdditive = await this.consultantService.generateAdditive(this.consultant, additive);
            if(responseAdditive.success){
                if(additive.additiveType == 1)
                    this.toastr.success("Termo aditivo gerado com sucesso");
                else if(additive.additiveType == 2) {
                    this.toastr.success("Renovação gerada com sucesso");
                    this.closeModalAdditive.nativeElement.click();
                }
                else if(additive.additiveType == 3)
                   this.toastr.success("Alteração gerada com sucesso");
            } else {
                this.toastr.error('Erro interno no servidor', 'Módulo Consultor');
            };
            this.loading = false;
        } catch (error) {
            this.toastr.error('Erro interno no servidor', 'Módulo Consultor');
            this.loading = false;
        }
    }

    async generateConfidentialityTerm() {
        try {
            if(!this.validateDocumentGeneration('confidentiality'))
                return;

            if(this.consultant.generatedConfidentiality == false){
                this.redirect = false;
                let res = await this.edit();
                if(res._id){
                    this.toastr.warning("Gerando Termo de Confidencialidade...");
                    this.loading = true;
                    const response = await this.consultantService.generateConfidentialityTerm(this.consultant);
                    if(response.success) {
                        this.consultant.generatedConfidentiality = true;
                        this.toastr.success('Termo de confidencialidade gerado com sucesso');
                        this.toastr.success('Consultor atualizado!');
                    } else {
                        this.toastr.error('Falha ao gerar termo de confidencialidade!');
                    }
                } else {
                    this.toastr.error('Erro interno no servidor', 'Módulo Consultor');
                }
                this.loading = false;
            }
        } catch (error) {
            this.toastr.error('Erro interno no servidor', 'Módulo Consultor');
            this.loading = false;
        }
    }

    async cepSearch(){
        let cep = this.consultant.personal.cep;
        cep = cep.replace(/\-/g, "");
        if(cep == '' || cep.length != 8){
            this.toastr.warning('CEP inválido');
        } else {
            this.toastr.warning('Realizando consulta ao CEP...');
            let response = await this.consultantService.getCep(cep);
            this.consultant.personal.address = response.logradouro;
            this.consultant.personal.district = response.bairro;
            this.consultant.personal.city = response.localidade;
            this.consultant.personal.state = response.uf;
        }
    }

    async cnpjSearch(){
        let cnpj = this.consultant.contract.cnpj;

        if(cnpj == '')
            return this.toastr.warning('CNPJ não pode ser vazio!');

        if(!this.consultantService.cnpjValid(cnpj))
            return this.toastr.warning('CNPJ inválido. CNPJ deve ter 14 caracteres!');

        this.toastr.warning('Realizando consulta ao CNPJ...');
        cnpj = cnpj.trim();

        let response = await this.consultantService.getCnpj(cnpj);
        response = JSON.parse(response);

        if(response.status == 'ERROR')
            this.toastr.error('Erro ao consultar o CNPJ', 'Módulo Consultor');

        if(this.consultantService.checkIfCnpjIsMei(response)) {
            this.consultant.contract.cnpj = '';
            this.consultant.contract.companyName = '';
            return this.toastr.warning(`O CNPJ ${cnpj} é do tipo MEI e não pode ser utilizado no sistema`, 'CNPJ Bloqueado');
        }

        this.consultant.contract.companyName = response.nome;
        this.consultant.contract.address = response.logradouro;
        this.consultant.contract.number = response.numero;
        this.consultant.contract.complement = response.complemento;
        this.consultant.contract.cep = response.cep;
        this.consultant.contract.district = response.bairro;
        this.consultant.contract.city = response.municipio;
        this.consultant.contract.state = response.uf;
    }

    async finishBond(){
        try{
            if(this.consultant.contract.generated) {
                if(!this.validateDocumentGeneration(this.typeGenerateDissolutionDischarge(this.optionDistract)))
                    return;
            } else {
                if(!this.validateDocumentGeneration('discharge')) return;
            };

            this.redirect = false;
            // this.consultant.contract.termination.documentGenerated = true;
            if(this.consultant.contract.generated){
                this.consultant.contract.termination.type = this.optionDistract;
                this.consultant.contract.end = this.consultant.contract.termination.end;
            } else {
                this.consultant.contract.termination.type = 1;
                this.consultant.consultantEnd = this.consultant.contract.termination.end;
            }

            let res = await this.edit();
            if(res._id){
                let responseDocument;
                this.loading = true;
                if(this.consultant.contract.generated){
                    this.toastr.warning("Gerando distrato...");
                    responseDocument = await this.consultantService.generateDistract(this.consultant);
                } else {
                    this.toastr.warning("Gerando termo de quitação...");
                    responseDocument = await this.consultantService.generateDischarge(this.consultant);
                }

                if(responseDocument.success) {
                    this.distractGenerated = true;
                    this.consultant.contract.termination.documentGenerated = true;
                    this.toastr.success(`${this.consultant.contract.generated ? 'Distrato' : 'Termo de Quitação'} gerado com sucesso`);
                    this.toastr.success('Consultor atualizado!');
                } else {
                    this.toastr.error('Erro interno no servidor', 'Módulo Consultor');
                }
            } else {
                this.toastr.error('Erro interno no servidor', 'Módulo Consultor');
            }
            this.loading = false;
        } catch (error) {
            this.toastr.error('Erro interno no servidor', 'Módulo Consultor');
            this.loading = false;
            this.router.navigate(['/consultants']);
        }
    }

    calculateHourValue() {
        let kind = this.consultant.contract.kind;
        let honor = this.consultant.contract.honorarium;

        if (kind === ContractType.CLT
            || (kind === ContractType.PJ && honor === HonorariumType.HoraFechada)) {
            this.consultant.contract.hourValue = this.consultantService.calculateHourValue(this.consultant);
            this.disableHourValue = true;
        } else {
            this.disableHourValue = false;
        }
    }

    async verifyEmail(){
        this.trim('fcEmail');
        this.trim('email');
        if(!this.consultant.fcEmail)
            return this.toastr.warning("E-mail FCamara é obrigatório.");
        if(!this.consultant.personal.cpf)
            return this.toastr.warning("CPF é obrigatório");

        const response = await this.publicConsultantService.verifyIfEmailExists(this.consultant.fcEmail);
        if(response.error) {
            this.toastr.error(response.error.message);
            this.consultant.fcEmail = "";
        } else if(response.emailExists) {
            this.toastr.warning(`E-mail FC ${this.consultant.fcEmail} já está em uso!`);
            this.consultant.fcEmail = "";
        }
    }

    async verifyCPF(){
        const clearCpf = () => {
            this.consultant.personal.cpf = "";
            this.consultant.fcEmail = "";
            this.consultant.freshServiceId = "";
            this.disableFcEmail();
        }

        try {
            const cpf = this.consultant.personal.cpf;
            if(cpf == null || cpf == ""){
                clearCpf();
                return this.toastr.warning("O CPF é obrigatório!");
            }

            if(!(this.commonHelper.cpfValidator(cpf))){
                clearCpf();
                return this.toastr.warning("CPF inválido");
            }

            let responseCpfExists = await this.consultantService.verifyCPF(this.consultant);
            if(responseCpfExists.length > 0 && responseCpfExists[0]._id != this.consultant._id){
                clearCpf();
                return this.toastr.warning(`Este CPF é utilizado pelo consultor: ${responseCpfExists[0].name}`,"CFP já está em uso!");
            }

            let responseFreshService = await this.consultantService.getFreshServiceEmailByCPF(cpf);
            if(responseFreshService && responseFreshService.fcEmail) {
                this.consultant.fcEmail = responseFreshService.fcEmail;
                this.consultant.freshServiceId = responseFreshService.freshServiceId;
                this.verifyEmail();
            } else {
                this.toastr.warning('Erro ao resgatar FCEmail com base no CPF');
            }
            this.disableFcEmail();
        } catch(err) {
            this.consultant.fcEmail = "";
            this.consultant.freshServiceId = "";
            this.disableFcEmail();
            this.toastr.warning('Erro ao resgatar FCEmail com base no CPF');
        }
    }

    disableFcEmail(){
        const control = this.consultantForm.get('fcEmail');
        if(!this.consultant.personal.cpf)
            control.disable();
        else
            control.enable();
    }

     async verifyCPFCNPJPixKey(){
        if(!this.consultant.payment.keyPix){
            this.toastr.warning("O CPF/CNPJ é obrigatório!");
            this.consultant.payment.keyPix = "";
        } else if(this.commonHelper.cpfValidator(this.consultant.payment.keyPix)){
            this.pixCpfValid = true;
        } else if(this.companiesService.cnpjValid(this.consultant.payment.keyPix)){
          this.pixCnpjValid = true;
        }else if(!this.pixCnpjValid && !this.pixCpfValid){
          this.toastr.warning('CPF/CNPJ inválido.');
          this.consultant.payment.keyPix = "";
        }
      }

    cnpjValid(cnpj: String) {
        return this.consultantService.cnpjValid(cnpj);
    }

    async getCnpj(cnpj: String) {
        return await this.consultantService.getCnpj(cnpj);
    }

    randomPixKeySearch(){
        if(!this.consultant.payment.keyPix) {
            this.toastr.warning('Aleatória não pode ser vazio');
        } else if (!this.consultantService.randomPixKeyValid(this.consultant.payment.keyPix)) {
            this.toastr.warning('Aleatória inválida. Aleatória deve ter 36 caracteres!');
            this.consultant.payment.keyPix = '';
        }
    }

    async verifyEmailPixKey(){
        this.trimPixKey();
        if(!this.consultant.payment.keyPix){
         this.toastr.warning("O Email é obrigatório!");
        }else{
            if (!(new RegExp(this.emailPattern).test((this.consultant.payment.keyPix).toString()))) {
                this.toastr.warning(`Digite um email válido.`, "Email inválido!");
                this.consultant.payment.keyPix = "";
            }
        }
    }

    changeCustomer(){
        if(this.consultant.contract.customers.length <= this.customersDropdown.selected.length){
            let diff = _.differenceWith(this.customersDropdown.selected, this.consultant.contract.customers, (a,b)=> a.id == b._id )
            this.consultant.contract.customers.push({
                _id:diff[0].id,
                name:diff[0].itemName
            })
        }
        else {
            let diff = _.differenceWith(this.consultant.contract.customers,this.customersDropdown.selected, (a,b)=> a._id == b.id )
            _.remove(this.consultant.contract.customers, item => item._id == diff[0]._id)
        }
    }

    changeSkill(){
        if(this.consultant.skills.length <= this.skillsDropdown.selected.length){
            let diff = _.differenceWith(this.skillsDropdown.selected, this.consultant.skills, (a,b)=> a.id == b._id )
            this.consultant.skills.push({
                _id:diff[0].id,
                name:diff[0].itemName
            })
        }
        else {
            let diff = _.differenceWith(this.consultant.skills,this.skillsDropdown.selected, (a,b)=> a._id == b.id )
            _.remove(this.consultant.skills, item => item._id == diff[0]._id)
        }
    }

    async getS3Files(){
        this.fileList = await this.awsService.getFiles(this.consultant._id);
    };

    async getS3FilesConsultantTermination(id:string) {
        const file = await this.awsService.getFiles(`consultant-termination/${id}`);
        this.fileList.push(...file);
    };

    selectFile(event) {
        this.selectedFiles = event.target.files;
    }

    async deleteFile(name){
        await this.awsService.deleteFile(name);
        await this.getS3Files();
    }

    async upload(uploadType?: string) {
        try {
            let id = this.consultant._id;
            let length = this.selectedFiles.length;
            for(let i=0; i<length; i++){
                const file = this.selectedFiles.item(i);
                if (uploadType) {
                    await this.awsService.uploadfile(file,`${uploadType}/${id}`);
                } else {
                    await this.awsService.uploadfile(file,id);
                }
            }

            if (!uploadType) {
                await this.getS3Files();
            }
        } catch (error) {
            console.log(error);
        }
    }

    async download(name){
        this.downloadUrl = await this.awsService.download(name);
    }

    verifyDate(date,doc,field){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.consultant[`${doc}`][`${field}`] = "";
        }
    }

    verifyDate2(date,field){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.consultant[`${field}`] = "";
        }
    }

    verifyDate3(date,doc,doc2,field){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.consultant[`${doc}`][`${doc2}`][`${field}`] = "";
        }
    }

    verifyDate4(date,field){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.additiveHistory[`${field}`] = "";
            this.validDateAdditive = false;
        } else {
            this.validDateAdditive = true;
        }
    }

    verifyDateContractStart(date,doc,field){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.consultant[`${doc}`][`${field}`] = "";
            this.consultant[`${doc}`][`end`] = "";
        } else {
            // let dateAux = moment(this.consultant.contract.begin, "DD/MM/YYYY").add(9,'months');
            // this.consultant.contract.end = moment(dateAux).format("DDMMYYYY");
        }
    }

    changeCnae(){
        this.consultant.contract.sapServiceCode = this.cnaes.find(x => x.cnae === this.consultant.contract.cnae).sapItemCode;
    }

    loggedUserValidation(){
        const positionHead = 35;
        const positionGR = 16;
        const positionAnalistaGov = 20;
        if(this.user.permission == 'rs') {
            let allUsers = this.responsibles.map(user => user._id);
            const consultantIsUser = allUsers.find(u => u === this.consultant._id);
            if(consultantIsUser)
                this.blockLoggedUser = true;
        }
    }

    openAddModalBank(){
        this.bankCode = null
        this.bankName = ""
        this.bankCountry = ""
    }

    async addBank(){
        try {
            const response = await this.bankService.postBank({
                name: this.bankName,
                countryCode: this.bankCountry.toUpperCase(),
                bankCode: this.bankCode
            });

            if(response._id) {
                this.banks = await this.bankService.getBanks();
                this.toastr.success('Banco criado com sucesso');
            }
        } catch(err) {
            console.log(err);
            this.toastr.error('Erro ao criar o banco');
        }
    }

    openEditBank(bank:any){
        this.bankForEdit.bankCode = bank.bankCode;
        this.bankForEdit.bankName = bank.name;
        this.bankForEdit.bankCountry = bank.countryCode;
        this.bankForEdit.bankSapCode = bank.sapCode;
    }

    async editBank(){
        try {
            let bankEdit = {
                "active": true,
                "bankCode": this.bankForEdit.bankCode,
                "name": this.bankForEdit.bankName,
                "countryCode": this.bankForEdit.bankCountry.toUpperCase(),
                "sapCode": this.bankForEdit.bankSapCode,
            }

            const response = await await this.bankService.updateBank(bankEdit);
            if(response._id) {
                this.banks = await this.bankService.getBanks();
                this.toastr.success('Banco atualizado com sucesso');
            }
        } catch(err) {
            console.log(err);
            this.toastr.error('Erro ao atualizar o banco');
        }
    }

    openDeleteBank(bank:any){
        this.bankCode = bank.bankCode;
    }

    async removeBank() {
        try {
            const response = await this.bankService.removeBank(this.bankCode);
            if(response.message == 'Deleted') {
                this.banks = await this.bankService.getBanks();
                this.toastr.success('Banco excluído com sucesso');
            }
        } catch(err) {
            console.log(err);
            this.toastr.error('Erro ao excluir o banco');
        }
    }

    documentsInProgressIncomplete() {
        const isValueFilled = Number(this.consultant.contract.termination.value) >= 0;

        //BP não preenche o campo de valor, apenas os demais usuários
        const isValueFieldValid = this.isUserBp || (!this.isUserBp && isValueFilled);

        if(this.distractInProgress) {
            if(!isValueFieldValid ||
                !this.consultant.contract.termination.start || !this.consultant.contract.termination.end ||
                !this.consultant.contract.end){
                this.toastr.error('Há campos obrigatórios que não foram preenchidos no formulário. Verifique a data fim de contrato e os campos de encerramento.', 'Erro ao salvar distrato'); return true;
            };
            this.consultant.contract.end = this.consultant.contract.termination.end;
        } else if(this.dischargeInProgress) {
            if(!isValueFieldValid ||
                (!this.consultant.contract.termination.qtdHours && Number(this.consultant.contract.termination.qtdHours) != 0) ||
                !this.consultant.contract.termination.start || !this.consultant.contract.termination.end ||
                !this.consultant.consultantEnd){
                this.toastr.error('Há campos obrigatórios que não foram preenchidos no formulário. Verifique a data fim do consultor e os campos de encerramento.', 'Erro ao salvar termo de quitação'); return true;
            };
            this.consultant.consultantEnd = this.consultant.contract.termination.end;
        };

        return false;
    }

    validateDocumentGeneration(type: string) {
        let documentTypes = {
            'contract': {
                'invalid': this.contractInvalid() || this.consultantPersonalInvalid() ||
                    (this.consultant.contract.honorarium == 1 && !this.consultant.contract.hourValue) ||
                    (this.consultant.contract.honorarium == 2 && !this.consultant.contract.totalValue) ||
                    Number(this.consultant.contract.position) == 0,
                'group': ['personal','contract']
            },
            'discharge': {
                'invalid': this.consultantPersonalInvalid() || !this.consultant.consultantEnd ||
                    (!this.consultant.contract.termination.qtdHours && this.consultant.contract.termination.qtdHours != 0) ||
                    (!this.consultant.contract.termination.value && this.consultant.contract.termination.value != 0),
                'group': ['personal']
            },
            'distractMutualAgreement': {
                'invalid': this.contractInvalid() || this.consultantPersonalInvalid() ||
                    !this.consultant.contract.end,
                'group': ['personal','contract']
            },
            'distractByTheContractor': {
                'invalid': this.contractInvalid() || this.consultantPersonalInvalid() ||
                    !this.consultant.contract.end,
                'group': ['personal','contract']
            },
            'additiveValueAdjustment': {
                'invalid': this.contractInvalid() || this.consultantPersonalInvalid(),
                'group': ['personal','contract']
            },
            'additiveRenovation': {
                'invalid': this.contractInvalid() || this.consultantPersonalInvalid(),
                'group': ['personal','contract']
            },
            'additiveChangeCompany': {
                'invalid': this.contractInvalid(),
                'group': ['contract']
            },
            'confidentiality': {
                'invalid': this.consultantPersonalInvalid() || !this.consultant.contract.begin,
                'group': ['personal']
            },
            'individualAgreementHoliday': {
                'invalid': this.consultantPersonalInvalid(),
                'group': ['personal']
            },
        };

        if(documentTypes[type].invalid) {
            let personalData = this.personalDataInvalid && documentTypes[type].group.includes('personal') ?
                '\n•Dados pessoais: Nome, RG, CPF, dados de endereço e estado civil.' : '';
            let contractData = this.contractDataInvalid && documentTypes[type].group.includes('contract') ?
                '\n•Dados de contrato: CNPJ, razão social, fim de contrato e dados de endereço empresa.' : '';
            this.toastr.error(`Há dados obrigatórios no documento Clicksign que não foram preenchidos no consultor.\n${personalData}\n${contractData}`, 'Formulário incompleto');
            return false;
        };
        return true;
    };

    contractInvalid() {
        let contractDataInvalid = !this.consultant.contract.cnpj ||
            !this.consultant.contract.companyName ||
            !this.consultant.contract.address ||
            !this.consultant.contract.number ||
            !this.consultant.contract.cep ||
            !this.consultant.contract.city ||
            !this.consultant.contract.state ||
            Number(this.consultant.contract.state) == 0;
        this.contractDataInvalid = contractDataInvalid;
        return contractDataInvalid;
    }

    consultantPersonalInvalid() {
        let personalDataInvalid = !this.consultant.name ||
            !this.consultant.personal.rg ||
            !this.consultant.personal.cpf ||
            !this.consultant.personal.address ||
            !this.consultant.personal.number ||
            !this.consultant.personal.cep ||
            !this.consultant.personal.city ||
            !this.consultant.personal.state ||
            Number(this.consultant.personal.state) == 0 ||
            !this.consultant.personal.civilStatus ||
            Number(this.consultant.personal.civilStatus) == 0;
        this.personalDataInvalid = personalDataInvalid;
        return personalDataInvalid;
    }

    openModalContract(typeContract, typeAdtive?) {
        this.reloadDocModal = !this.reloadDocModal;
        this.typeContractModal = typeContract;
        this.typeAdtiveModal = typeAdtive;

        if(!this.validateDocumentGeneration(this.typeContractModal))
            return;
        else
            this.buttonOpenModalContract.nativeElement.click();
    }

    async getConsultantData(event: any) {
      this.consultant = event;
      this.verifyDocumentTypeAndGenerate(this.typeContractModal, this.typeAdtiveModal);
    }

    async verifyDocumentTypeAndGenerate(docType: String, additive?: any): Promise<void> {
      this.toastr.warning("Carregando...");
      switch(docType) {
        case 'contract':
            await this.generateContract();
            break;
        case 'discharge':
        case 'distractMutualAgreement':
        case 'distractByTheContractor':
            await this.finishBond();
            break;
        case 'additiveValueAdjustment':
        case 'additiveChangeCompany':
            await this.approveAdditive(additive);
            break;
        case 'additiveRenovation':
            this.redirect = false;
            let res = await this.edit();
            if(res._id){
                await this.generateAdditive(this.consultant.contract.additivesHistory[this.typeAdtiveModal]);
                this.router.navigate(['/consultants']);
            }
            break;
        case 'confidentiality':
            await this.generateConfidentialityTerm();
            break;
        default:
            this.toastr.error('Erro ao tentar gerar um documento.', '', {timeout: 3000})
            break;
      }
    }

    typeGenerateDissolutionDischarge(type) {
      switch (type) {
          case 2: return 'distractMutualAgreement';
          case 3: return 'distractByTheContractor';
          default: return '';
      }
    }

    onPixTypeChange() {
        this.pixValidation.onPixTypeChange(this.consultant.payment.typePix, this.consultantForm.get("keyPix"))
        this.textMask = {mask: false}
    }

    async verifyPixKey(){
        if (!this.consultant.payment.typePix) {
            return
        }
        this.pixCpfValid = false;
        this.pixCnpjValid = false;

        let typePix = this.consultant.payment.typePix

        switch (typePix) {
            case PixKeyType.phone:
                if(!this.commonHelper.phoneNumberValidator(this.consultant.payment.keyPix)){
                    this.toastr.warning('CPF/CNPJ inválido.');
                    this.consultant.payment.keyPix = "";
                }
                break;
            case PixKeyType.email:
                this.verifyEmailPixKey();
                break;
            case PixKeyType.cpf_cnpj:
                this.verifyCPFCNPJPixKey();
                break;
            case PixKeyType.randomized:
                this.randomPixKeySearch();
                break;
            default:
                break;
        }
    }

    onChangeMask() {
        let typePix = this.consultant.payment.typePix;
        switch (typePix) {
            case PixKeyType.phone:
                this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.phone)
                break;
            case PixKeyType.cpf_cnpj:
                let inputValue = this.consultant.payment.keyPix;
                if(!inputValue) return;

                if (inputValue && inputValue.length > 14)
                    this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.cpf_cnpj, true);
                else
                    this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.cpf_cnpj, false);
                break;
            case PixKeyType.randomized:
                this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.randomized)
                break;
            default:
                break;
        }
    }

    validateKeyPix(control: AbstractControl){
        if(!control.value)
            return {keyPix:true}
        return null;
    }

    calculateHourValueBenefits() {
        let kind = this.consultant.contract.kind;
        let honor = this.consultant.contract.honorarium;

        if (kind === ContractType.CLT
            || (kind === ContractType.PJ && honor === HonorariumType.HoraFechada)) {
            this.consultant.contract.hourValueBenefits = this.consultantService.calculateHourValueBenefits(this.consultant);
            this.disableHourValue = true;
        } else {
            this.disableHourValue = false;
        }
    }

    cancelNewAdditive() {
        this.validDateAdditive = false;
        this.additiveOption = 0;
        this.additiveHistory = new Additive();
        this.additiveHistory.date = "";
        this.newAdditiveIncluded = false;

        this.showBtnNewAdditiveReadjustment = true;
        this.showBtnNewAdditiveRenew = true;
        this.showBtnNewAdditiveChangeCompany = true;

        this.toastr.warning('Novo aditivo cancelado');
    }

    async getAdditiveData(event: any): Promise<void> {
        this.additiveHistory = event;
        //Criação de aditivo pela BP
        if(this.user.permission != GUARDS.GOVERNANCE) {
            this.additiveHistory.pendingGovApproval = true;
            if (this.additiveOption == 2) {
                this.additiveHistory.pendingGovApproval = false;
            }
            this.consultant.contract.additivesHistory.push(this.additiveHistory);
            const FINANCIAL_CONTROLS = 8;
            await this.consultantService.notifyDP(this.consultant, FINANCIAL_CONTROLS, this.additiveOption);
            this.closeModalAdditive.nativeElement.click();
            if (this.additiveOption !== 2) {
                this.router.navigate(['/consultants']);
            }
            return;
        } else {
            this.toastr.info("Após o preenchimento, salve o consultor para registrar o novo aditivo.", '', { timeOut: 5000 });
        }

        if(this.additiveOption == 1) {
            this.showBtnNewAdditiveRenew = false;
            this.showBtnNewAdditiveChangeCompany = false;
        } else if(this.additiveOption == 2) {
            if(!this.validateDocumentGeneration('additiveRenovation'))
                return;
            this.consultant.contract.end = '';
            this.additiveHistory.pendingApproval = false;
            this.additiveHistory.pendingGovApproval = false;
            this.consultant.contract.additivesHistory.push(this.additiveHistory);
            this.openModalContract('additiveRenovation');
        } else if(this.additiveOption == 3) {
            this.showBtnNewAdditiveReadjustment = false;
            this.showBtnNewAdditiveRenew = false;
        }
        if(this.closeModalAdditive) this.closeModalAdditive.nativeElement.click();
        this.newAdditiveIncluded = true;
    }

    cancelOffboardingForm() {
        this.completedOffboardingForm = false;
        this.consultant.contract.termination.freshServiceOffboardingForm = new FreshServiceOffboardingForm();
        this.consultant.contract.termination.freshServiceOffboardingForm.laptopTransportType = "";
    }

    getOffboardingForm() {
        this.completedOffboardingForm = true;
    }

    loadFreshServiceOffboardingForm() {
        const {
            _id,
            name,
            email,
            contract: {kind = '', companyName = '', cnpj = ''},
            personal: {cpf = ''},
            personal: {address = ''},
            personal: {number = ''},
            personal: {district = ''},
            personal: {city = ''},
            personal: {state = ''},
            personal: {cep = ''},
        } = this.consultant;
        return {
            _id,
            name,
            email,
            cpf,
            address,
            number,
            district,
            city,
            state,
            cep,
            kind,
            companyName,
            cnpj
        }
    }

    loadOffboardingDataByConsultant() {
        if(!this.completedOffboardingForm) {
            const freshServiceOffboardingFormData = this.loadFreshServiceOffboardingForm();
            this.consultant.contract.termination.freshServiceOffboardingForm.loadData(freshServiceOffboardingFormData);
            this.consultant.contract.termination.freshServiceOffboardingForm.laptopTransportType = "";
        }
    }

    setApprovalFlag(permission: string) {
        switch (permission) {
            case GUARDS.DP:
                this.consultant.contract.termination.pendingDPApproval = false;
                this.consultant.contract.termination.pendingGovApproval = true;
                this.notifyDepartmentsForApproval();
                break;
            case GUARDS.GOVERNANCE:
                this.consultant.contract.termination.pendingGovApproval = false;
                if(this.consultant.contract.kind != ContractType.PJ) {
                    this.consultant.contract.termination.pendingDPApproval = true;
                    this.notifyDepartmentsForApproval();
                }
                break;
            default:
                this.consultant.contract.termination.pendingGovApproval = true;
                if(this.consultant.contract.kind != ContractType.PJ)
                    this.consultant.contract.termination.pendingDPApproval = true;
                this.notifyDepartmentsForApproval();
                break;
        }

        this.notifyInfra();
    }

    approveTermination(): void {
        const permission = this.user.permission;
        const isValueFilled = !!this.consultant.contract.termination.value;

        if (permission === GUARDS.GOVERNANCE) {
            if (!isValueFilled && this.consultantService.isContractTypePJ(this.consultant)){
                this.toastr.error('Preencha o valor a ser pago para seguir com a aprovação.', 'Erro ao aprovar');
                return;
            }

            this.consultant.contract.termination.pendingGovApproval = false;
        }
        if (permission === GUARDS.DP)
            this.consultant.contract.termination.pendingDPApproval = false;

        this.edit();
    }

    disapproveTermination(): void {
        if(this.consultant.contract.kind != ContractType.PJ)
            this.consultant.contract.termination.pendingDPApproval = true;
        this.consultant.contract.termination.pendingGovApproval = true;
    }

    async createServiceTicket(type: string): Promise<void> {
        const errorMessageIfFreshserviceFails = 'Não foi possível registrar automaticamente um chamado de Offboarding, acesse o Portal Infra e crie-o manualmente';
        try {
            this.loading = true;
            const freshServiceOffboardingForm = this.consultant.contract.termination.freshServiceOffboardingForm;
            const responseTicket = await this.consultantService.createTicket(freshServiceOffboardingForm, type);
            this.loading = false;
            if(responseTicket && responseTicket.success)
                this.toastr.success("Um chamado de Offboard foi registrado", "Portal Infra");
            else {
                this.toastr.warning(errorMessageIfFreshserviceFails, 'Erro no Portal Infra', { dismiss: 'controlled' })
                    .then((t: Toast) => { setTimeout(() => { this.toastr.dismissToast(t) }, 10000) });
            }
        } catch(err) {
            this.loading = false;
            this.toastr.warning(errorMessageIfFreshserviceFails, 'Erro no Portal Infra', { dismiss: 'controlled' })
                .then((t: Toast) => { setTimeout(() => { this.toastr.dismissToast(t) }, 10000) });
        }
    }

    finishBondFormAllowedPermission(): void {
        const allowed = [
            GUARDS.GOVERNANCE,
            GUARDS.BUSINESSPARTNER,
            GUARDS.DP,
            GUARDS.PEOPLE,
        ];
        this.allowedToFillFinishBondForms = allowed.includes(this.user.permission)
    }
}



// WEBPACK FOOTER //
// ./src/app/views/consultants/consultant-edit/consultant-edit.component.ts